

export const dataDiamond =
    [
        {
            name: "Abigail Caitlyn Electra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Aiden Alcander Saksono",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Alvita Yuniar & Nafisha Inastasya Ekoputri",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Amanda Taslim",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Audrey Gotama",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Basilea Setiadarma",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Beverlyn Mettakhemadevi Winata",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Beverlyn Mettakhemadevi Winata",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Bianca Marvella",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Bravian Abner Trisno",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Britney Valerie Ramba",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Brody Christopher Chairumin",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Bryna Lie Hartanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Calista Christalyn Santoso & Calissa Christella Santoso",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Callia Kardiono",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Calya Anara Wijaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Catherine Tjahja",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Cathleen Arabella Wijaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Cathlen Silau & Faustine",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Celine Gabriella Amijaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Celline Wisal",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Charice Elleanore Konggo Budiman",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Charlize Evangeline Tan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chelsea Azalia Winarto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chloe Madelyn The",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chloe Madelyn The",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chloe Sinjaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Christophorus Satrio",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Claire Audrey Sudarman & Cornelius Carlton Chandra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Claire Audrey Sudarman & Cornelius Carlton Chandra & Naomi Kaitlyn & Naomi Thelma",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Claire Theresa Kusumo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Claire Theresa Kusumo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Constanza Vivecka Tanoyo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Constelle Carsson Lim",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Darlene Manuella Gani & Lori Mikaella Gani",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Eiden Kenneth Ongkoraharjo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Elaine Lius",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Elaine Violet Santosa",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Emily Lanya Santoso",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Enid Iandra Darmawan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ethan Limandibrata",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Everly Jillya Kho",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Francois Maverick Alexandrite Joseph",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Freya Venezia Bong",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Galilee Jethrokusumo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Genevieve Annabeth Christian",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Giorgio Theodore Khoe",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Glory Esther Simanjuntak",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Hayley Abigail Cahyadi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Hillary Gabrielle Koeswanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ivanna Hawcentia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jane Adelene Sun",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jayden James Wang",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jean Agatha Florence Lie",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jessica Ivy Pratignyo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jesslyn Ivanka Wu",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jiwoo Jenny Kim",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jo Princeton Hariadi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Joan Annette & Sean Dillon",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Johannes Arsene Santoso",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jollyn Victoria Wu",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jordan Eli Santoso",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Josephine Davina",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Joshua Aditya Nugroho",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Karen Ivy Goenarno",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Karin Michiko Pangestoe",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Karuna Leticia Anandi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kathleen Kho",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Khansa Aqila Ghassani",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Leticia Mikhaela Amijaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Liam Jensen Darmawan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Lionel Nathan Wijaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Louis McLawrence Hendra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Louise Michelle Emerald Joseph",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Mandy Darmawan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Maria Keisha Angel Haswin",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Megan Magdalene Liem",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Mevelaine Susanto & Rajamin Samosir",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Michael Aaron Reinhart",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Michael Edmund Kuncoro",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Monacella Gracia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Nadya Indriantina",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Naomi Thelma & Stephanie Yap",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Nataren Velice",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Nayla Alia Putri",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Parish Emmelie Nyoto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Phylicia Eriko Yang",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Prapta Dimatteo Pratama",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Rachel Untoro",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Rafaela Caitlyn Galenka Panggabean",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Reagan Kenji Liu",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Rebecca Shannen Lie",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Renata Chelsea Widjaja",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ryan Hugo Purnomo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sally Sugiarto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sean Carsten Ho",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Shannon Richelle Johannanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sharlyn Chandra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sinclair Justin Gohandi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Tiara Aysha Al Kayyas",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Trisha Lyndt Kusuma",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Tsui Hailey Tjandra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Wyndon Langford Aliwarga",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Zoey Fiona Loesin",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Aaron Joshua Gondokusumo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Abelando Susiarjo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Abiyyu Jingga Abiyyu Athallah",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Alesa Jillian Tjen",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Alessa Elbali Fernando",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Alf Elijah Beloved Sigarlaki",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Alma Azkiya Ramadhani",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Alyssa Ong Yu Xuan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Amabelle Vidya Aditya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Anaya Isha Atira Hutapea",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Audrina Valerie Widjanarko & Caithlyn Evangeline Putra & Carinna Aurelia Hendarto & Claire Alexia Oei",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Bryan Kings Tan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Carnelian Graciella Chen",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Cassia Florentine Basuki",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Cathrine Luvita",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Celestyn Evangeline Emmanuella",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Cherish Bali",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chiara Nadira Setiawan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chloe Adeline Sentono",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chloe Davina Tan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Chloe Florie Chang",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Claire Alexia Oei",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Claire Audrey Sudarman",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Clarisse Genevie Sidik",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Daniella Catherine Elizabeth Theh",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Delicia Nicolyn Sutopo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Earlene Celestyn Ottilia Wang",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Edward Chandra & Febriyanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Elliot Tjendra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Emily Janetta Chen",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ethan Gunardi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ethan Sumedha",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Fatima Sofia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Felycia Elvina Ananta",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Fiona Goeretthie Masawan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Furio Hiroki Yanata",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gabrianezekiel Sinaga",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gabriel Alexanderian Pasaribu",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Geaverston Mckinlley Lawrence Fanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Georgina Cornelia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gillian Teja Prawiro",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Glow Presley Wangsa",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gracelyn Emmanuela Gan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gwen Sabriela Nugroho",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gwyneth Alicia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Gwyneth Madeline Liechelle Fanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Hana Abigail Saputra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Hannah Abigail Nixon",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Harold Evano Hartanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Hezekiel Sibuea",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Isabella Nikita Sumargo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jacqueline",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jathniel Beryl Reagan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jaydee Justin Limpuno",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jeremy Axel Poernomo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jeslyn Cornelia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Jocelyn Gabrielle Alexander",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Josephine Gabrielle Alexander",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kani Kalavati",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kayla Agatha Kurniawan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kenisha Darman",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kenward Keegan Kusumohadi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kenzo Simanjaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kimberly Della Sophie Hutapea",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Kylie Adeline Colins",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Letitia Charlotte Liang",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Maria Olivia Christabel Elnathan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Mary Kate Onggowijoyo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Maryam Almayrha Nugraha",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Matthew Joshua Elnathan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Matthew Wilson Tanto Widjaja",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Meghan Alisa Wu",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Michael Lewin Halomoan Sinaga",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Michael Phillipe Andree",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Michael Phillipe Andree",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Mikayla Wong",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Mikhaila Sugiharto Iskandar & Jonathan Sugiharto Iskandar",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Minka Corine Lim",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Monacella Gracia",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Moselle Emerald Gun",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Nadya Ie",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Natanisya Jemima Benget Siahaan",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Olliver Revergo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Philomena Cetta Prameshwary",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Rachel Margareth Purba",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Reika Keola Aditiawarman",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Reina Agatha Tamtomo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Renzo Alvaro Aditiawarman",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Richelle Ileanna Kusnadi",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ricky Meydiyanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Ryan Limanto",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Samantha Brielle Sujoko",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sean Skywalker",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Serena Chandra",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sharon Everlyn Tanto Widjaja",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Shenika Junior Ivanka",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sherleen Emmanuel",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Sophilia Adler Winston",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Starielle Adeline Winston",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Talulla Cetta Wijaya",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Teresa Carissa",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Teresa Carissa",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Zach Arsa Soelistyo",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        },
        {
            name: "Zoey Belle Agus",
            country: "indonesia",
            city: "Jakarta",
            YoutubeLink: "",
            event: "2025 The Sound of Asia"
        }
    ]

